__turbopack_context__.v({
  "card": "HomepageV2SectionCard-module-scss-module__w58SlW__card",
  "dark": "HomepageV2SectionCard-module-scss-module__w58SlW__dark",
  "footer": "HomepageV2SectionCard-module-scss-module__w58SlW__footer",
  "hpv2Blink": "HomepageV2SectionCard-module-scss-module__w58SlW__hpv2Blink",
  "hpv2DemoBounce": "HomepageV2SectionCard-module-scss-module__w58SlW__hpv2DemoBounce",
  "hpv2DemoFadeIn": "HomepageV2SectionCard-module-scss-module__w58SlW__hpv2DemoFadeIn",
  "hpv2DemoProgress": "HomepageV2SectionCard-module-scss-module__w58SlW__hpv2DemoProgress",
  "hpv2DemoScaleIn": "HomepageV2SectionCard-module-scss-module__w58SlW__hpv2DemoScaleIn",
  "hpv2DemoSlideIn": "HomepageV2SectionCard-module-scss-module__w58SlW__hpv2DemoSlideIn",
  "hpv2FadeLeft": "HomepageV2SectionCard-module-scss-module__w58SlW__hpv2FadeLeft",
  "hpv2FadeRight": "HomepageV2SectionCard-module-scss-module__w58SlW__hpv2FadeRight",
  "hpv2FadeUp": "HomepageV2SectionCard-module-scss-module__w58SlW__hpv2FadeUp",
  "hpv2FloatA": "HomepageV2SectionCard-module-scss-module__w58SlW__hpv2FloatA",
  "hpv2FloatB": "HomepageV2SectionCard-module-scss-module__w58SlW__hpv2FloatB",
  "hpv2HeroFadeIn": "HomepageV2SectionCard-module-scss-module__w58SlW__hpv2HeroFadeIn",
  "hpv2HeroFadeInOpacity": "HomepageV2SectionCard-module-scss-module__w58SlW__hpv2HeroFadeInOpacity",
  "hpv2HeroSlideIn": "HomepageV2SectionCard-module-scss-module__w58SlW__hpv2HeroSlideIn",
  "hpv2PriceShimmer": "HomepageV2SectionCard-module-scss-module__w58SlW__hpv2PriceShimmer",
  "hpv2PulseDot": "HomepageV2SectionCard-module-scss-module__w58SlW__hpv2PulseDot",
  "hpv2ScaleUp": "HomepageV2SectionCard-module-scss-module__w58SlW__hpv2ScaleUp",
  "light": "HomepageV2SectionCard-module-scss-module__w58SlW__light",
  "scrollTarget": "HomepageV2SectionCard-module-scss-module__w58SlW__scrollTarget",
  "white": "HomepageV2SectionCard-module-scss-module__w58SlW__white",
});
